import { useMutation } from 'data-fetching-client';
import { CREATE_ASSET_SYNC_TASK } from '../../data/queries';
import { captureException } from '../../utils/captureException';
export function useCreateSyncTask(options = {}) {
  const [mutate, mutateOptions] = useMutation(CREATE_ASSET_SYNC_TASK, Object.assign({}, options, {
    onError: error => {
      var _options$onError;
      captureException(error, ['useCreateSyncTask']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
    }
  }));
  return Object.assign({
    mutate
  }, mutateOptions);
}